import {AxiosError} from 'axios';
import {UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';
import {useQuery} from '@eksab/hooks';
import type {Participant} from '@eksab/features/competition/types';

interface Return {
  data: Participant;
}

const queryKey = (groupID: string) => ['group-ranking-mine', groupID];

const queryFn = (groupID: string) => api.get<Return>(`rankings/mine?group=${groupID}`).then((res) => res.data.data);

export const useMyRankingQuery = (groupID: string, options?: UseQueryOptions<Participant, AxiosError>) =>
  useQuery<Participant, AxiosError>(queryKey(groupID), () => queryFn(groupID), {
    ...options,
    enabled: !!groupID && (options?.enabled ?? true),
  });

useMyRankingQuery.queryFn = queryFn;
useMyRankingQuery.queryKey = queryKey;
